<template>
<footer id="footer">
    <div class="footer-content container">
        <div class="footer-grid">
            <!-- Brand Section -->
            <div class="footer-brand">
                <router-link :to="{name:'home'}">
                    <img src="/img/LOGO-LUPA.jpg" alt="Lupa Empaques" class="footer-logo" />
                </router-link>
                <p class="brand-text">Soluciones integrales en empaques y diseño gráfico con más de 15 años de experiencia.</p>
            </div>

            <!-- Contact Section -->
            <div class="footer-contact">
                <h4>Contacto</h4>
                <ul>
                    <li><i class="fa fa-phone me-2"></i> +316 528 8931</li>
                    <li><i class="fa fa-envelope me-2"></i> empaqueslupa@gmail.com</li>
                    <li><i class="fa fa-map-marker-alt me-2"></i> Cali, Valle del Cauca</li>
                </ul>
            </div>

            <!-- Social Section -->
            <div class="footer-social">
                <h4>Síguenos</h4>
                <div class="social-links">
                    <a href="https://www.facebook.com/agencialupasas/" target="_blank"><i class="fab fa-facebook"></i></a>
                    <a href="https://www.instagram.com/empaqueslupa/" target="_blank"><i class="fab fa-instagram"></i></a>
                </div>
            </div>
        </div>
    </div>
    
    <div class="footer-bottom">
        <div class="container text-center">
            <p>&copy; 2026 Empaques Lupa. Todos los derechos reservados.</p>
        </div>
    </div>
</footer>
	
</template>

<script>
export default {
  name: 'efooter',

}
</script>

<style lang="scss" scoped>
#footer {
  background-color: #0c0c0c;
  color: #fff;
  padding: 60px 0 0;
  border-top: 1px solid rgba(255, 255, 255, 0.05);
}

.footer-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 40px;
  margin-bottom: 40px;
}

.footer-logo {
  height: 50px;
  margin-bottom: 20px;
}

.brand-text {
  color: #aaa;
  font-size: 14px;
  line-height: 1.6;
}

.footer-contact, .footer-social {
  h4 {
    color: #fff;
    font-family: 'Montserrat', sans-serif;
    font-size: 18px;
    font-weight: 700;
    margin-bottom: 20px;
    position: relative;
    padding-bottom: 10px;
    
    &::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      width: 40px;
      height: 2px;
      background: #713083;
    }
  }
}

.footer-contact ul {
  padding: 0;
  li {
    color: #ccc;
    margin-bottom: 12px;
    font-size: 14px;
  }
}

.social-links {
  display: flex;
  gap: 15px;
  
  a {
    color: #fff;
    font-size: 20px;
    transition: color 0.3s ease, transform 0.3s ease;
    
    &:hover {
      color: #713083;
      transform: translateY(-3px);
    }
  }
}

.footer-bottom {
  background: #000;
  padding: 20px 0;
  border-top: 1px solid rgba(255, 255, 255, 0.05);
  p {
    margin: 0;
    color: #666;
    font-size: 13px;
  }
}
</style>

